export const SHOW_ALERT = "SHOW_ALERT"
export const GET_CELLS = "GET_CELLS"
export const SHOW_TIP = "SHOW_TIP"